let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("16ooX")).then(() => parcelRequire('ltiRk'));